export default __webpack_public_path__ + "static/media/brand-image-06.35d093ab.jpg";